"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalConfirm = ModalConfirm;
exports.confirm = confirm;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ConfigProvider = _interopRequireDefault(require("../ConfigProvider"));
var _Button = _interopRequireDefault(require("../Button"));
var _index = _interopRequireDefault(require("./index"));
var _ModalMessage = _interopRequireDefault(require("./ModalMessage"));
var _excluded = ["onOk", "onCancel", "onClose"],
  _excluded2 = ["message", "description", "icon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * API 的方式唤起一个确认对话框
 * @param options
 * @returns 异步返回布尔值，为 true 则表示用户确认，为 false 则表示用户取消
 */
function confirm(options) {
  return new Promise(function (resolve) {
    var el = document.createElement('div');
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ConfigProvider.default, {
      classPrefix: options.prefix
    }, /*#__PURE__*/_react.default.createElement(ModalConfirmAPI, (0, _extends2.default)({}, options, {
      onOk: function onOk() {
        return resolve(true);
      },
      onCancel: function onCancel() {
        return resolve(false);
      },
      onExited: function onExited() {
        _reactDom.default.unmountComponentAtNode(el);
      }
    }))), el);
  });
}
function ModalConfirmAPI(_ref) {
  var onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    confirmModalProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];

  // 渲染之后，马上显示
  (0, _react.useEffect)(function () {
    return setVisible(true);
  }, []);
  var ok = function ok() {
    setVisible(false);
    onOk();
  };
  var cancel = function cancel() {
    setVisible(false);
    onCancel();
  };
  var close = function close() {
    setVisible(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  return /*#__PURE__*/_react.default.createElement(ModalConfirm, (0, _extends2.default)({
    visible: visible,
    onOk: ok,
    onCancel: cancel,
    onClose: close
  }, confirmModalProps));
}

/**
 * 提供原始的 ModalConfirm 组件。
 * 推荐使用 `Modal.confirm()` API 来简化用法
 */
function ModalConfirm(_ref2) {
  var message = _ref2.message,
    description = _ref2.description,
    icon = _ref2.icon,
    modalProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  (0, _react.useEffect)(function () {
    window.focus();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_index.default, modalProps, /*#__PURE__*/_react.default.createElement(_index.default.Body, null, /*#__PURE__*/_react.default.createElement(_ModalMessage.default, {
    icon: icon,
    message: message,
    description: description
  })), /*#__PURE__*/_react.default.createElement(_index.default.Footer, null, /*#__PURE__*/_react.default.createElement(ModalButton, modalProps)));
}
function ModalButton(_ref3) {
  var onOk = _ref3.onOk,
    _ref3$okText = _ref3.okText,
    okText = _ref3$okText === void 0 ? '确定' : _ref3$okText,
    onCancel = _ref3.onCancel,
    _ref3$cancelText = _ref3.cancelText,
    cancelText = _ref3$cancelText === void 0 ? '取消' : _ref3$cancelText;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onOk
  }, okText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "hole",
    onClick: onCancel
  }, cancelText));
}